/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as authOnboardingRouteImport } from './routes/(auth)/onboarding'
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authSignUpRouteImport } from './routes/(auth)/sign-up'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedAdminRouteRouteImport } from './routes/_authenticated/admin/route'
import { Route as AuthenticatedProfileRouteRouteImport } from './routes/_authenticated/profile/route'
import { Route as AuthAcceptInviteRouteImport } from './routes/auth/accept-invite'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuthInvitationRouteImport } from './routes/auth/invitation'
import { Route as AuthMcpCallbackRouteImport } from './routes/auth/mcp-callback'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedAdminBannersRouteImport } from './routes/_authenticated/admin/banners'
import { Route as AuthenticatedAdminBenchmarksRouteImport } from './routes/_authenticated/admin/benchmarks'
import { Route as AuthenticatedAdminBillingRouteImport } from './routes/_authenticated/admin/billing'
import { Route as AuthenticatedAdminOauthClientsRouteImport } from './routes/_authenticated/admin/oauth-clients'
import { Route as AuthenticatedAdminOrganizationsRouteImport } from './routes/_authenticated/admin/organizations'
import { Route as AuthenticatedAdminPlansRouteImport } from './routes/_authenticated/admin/plans'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin/users'
import { Route as AuthenticatedE2eMediaRouteImport } from './routes/_authenticated/e2e/media'
import { Route as AuthenticatedOrgOrgIdRouteRouteImport } from './routes/_authenticated/org.$orgId/route'
import { Route as AuthenticatedProfileConnectionsRouteImport } from './routes/_authenticated/profile/connections'
import { Route as AuthenticatedProfilePasswordRouteImport } from './routes/_authenticated/profile/password'
import { Route as AuthenticatedProfileSettingsRouteImport } from './routes/_authenticated/profile/settings'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedOrgOrgIdIndexRouteImport } from './routes/_authenticated/org.$orgId/index'
import { Route as AuthenticatedOrgOrgIdProductsRouteRouteImport } from './routes/_authenticated/org.$orgId/products/route'
import { Route as AuthenticatedOrgOrgIdSettingsRouteRouteImport } from './routes/_authenticated/org.$orgId/settings/route'
import { Route as AuthenticatedOrgOrgIdTalentsRouteRouteImport } from './routes/_authenticated/org.$orgId/talents/route'
import { Route as AuthenticatedOrgOrgIdBillingIndexRouteImport } from './routes/_authenticated/org.$orgId/billing/index'
import { Route as AuthenticatedOrgOrgIdProductsIndexRouteImport } from './routes/_authenticated/org.$orgId/products/index'
import { Route as AuthenticatedOrgOrgIdProductsProductIdRouteRouteImport } from './routes/_authenticated/org.$orgId/products/$productId/route'
import { Route as AuthenticatedOrgOrgIdSettingsBrandRouteImport } from './routes/_authenticated/org.$orgId/settings/brand'
import { Route as AuthenticatedOrgOrgIdSettingsGeneralRouteImport } from './routes/_authenticated/org.$orgId/settings/general'
import { Route as AuthenticatedOrgOrgIdTalentsIndexRouteImport } from './routes/_authenticated/org.$orgId/talents/index'
import { Route as AuthenticatedOrgOrgIdTalentsTalentIdRouteRouteImport } from './routes/_authenticated/org.$orgId/talents/$talentId/route'
import { Route as AuthenticatedOrgOrgIdUsageIndexRouteImport } from './routes/_authenticated/org.$orgId/usage/index'
import { Route as AuthenticatedOrgOrgIdUsersIndexRouteImport } from './routes/_authenticated/org.$orgId/users/index'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/route'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdIndexRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/index'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/bulk-jobs/route'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsRouteRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/models/route'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesRouteRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/nodes/route'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterRouteRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/roster/route'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesRouteRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/scenes/route'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/settings/route'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductRouteRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/sketch-to-product/route'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoRouteRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/video/route'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoRouteRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/vto/route'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsIndexRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/assets/index'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsAssetIdRouteRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/assets/$assetId/route'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsIndexRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/bulk-jobs/index'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsIndexRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/models/index'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsModelIdRouteRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/models/$modelId/route'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesIndexRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/nodes/index'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesCanvasIdRouteRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/nodes/$canvasId/route'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterIndexRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/roster/index'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterTalentIdRouteRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/roster/$talentId/route'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesIndexRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/scenes/index'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesSceneIdRouteRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/scenes/$sceneId/route'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsBrandRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/settings/brand'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsDeletionRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/settings/deletion'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsGeneralRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/settings/general'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsIntegrationsRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/settings/integrations'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsMembersRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/settings/members'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductIndexRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/sketch-to-product/index'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductProductIdRouteRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/sketch-to-product/$productId/route'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoIndexRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/video/index'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoVideoIdRouteRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/video/$videoId/route'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoIndexRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/vto/index'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoLookIdRouteRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/vto/$lookId/route'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsStpJobIdRouteRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/bulk-jobs/stp/$jobId/route'
import { Route as AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsVtoJobIdRouteRouteImport } from './routes/_authenticated/org.$orgId/workspace.$workspaceId/bulk-jobs/vto/$jobId/route'

const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => authRouteRoute,
} as any)
const authOnboardingRoute = authOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => authRouteRoute,
} as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => authRouteRoute,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => authRouteRoute,
} as any)
const authSignUpRoute = authSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => authRouteRoute,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAdminRouteRoute = AuthenticatedAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedProfileRouteRoute =
  AuthenticatedProfileRouteRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthAcceptInviteRoute = AuthAcceptInviteRouteImport.update({
  id: '/auth/accept-invite',
  path: '/auth/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthInvitationRoute = AuthInvitationRouteImport.update({
  id: '/auth/invitation',
  path: '/auth/invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthMcpCallbackRoute = AuthMcpCallbackRouteImport.update({
  id: '/auth/mcp-callback',
  path: '/auth/mcp-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedAdminBannersRoute =
  AuthenticatedAdminBannersRouteImport.update({
    id: '/banners',
    path: '/banners',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminBenchmarksRoute =
  AuthenticatedAdminBenchmarksRouteImport.update({
    id: '/benchmarks',
    path: '/benchmarks',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminBillingRoute =
  AuthenticatedAdminBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminOauthClientsRoute =
  AuthenticatedAdminOauthClientsRouteImport.update({
    id: '/oauth-clients',
    path: '/oauth-clients',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminOrganizationsRoute =
  AuthenticatedAdminOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminPlansRoute = AuthenticatedAdminPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedE2eMediaRoute = AuthenticatedE2eMediaRouteImport.update({
  id: '/e2e/media',
  path: '/e2e/media',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedOrgOrgIdRouteRoute =
  AuthenticatedOrgOrgIdRouteRouteImport.update({
    id: '/org/$orgId',
    path: '/org/$orgId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProfileConnectionsRoute =
  AuthenticatedProfileConnectionsRouteImport.update({
    id: '/connections',
    path: '/connections',
    getParentRoute: () => AuthenticatedProfileRouteRoute,
  } as any)
const AuthenticatedProfilePasswordRoute =
  AuthenticatedProfilePasswordRouteImport.update({
    id: '/password',
    path: '/password',
    getParentRoute: () => AuthenticatedProfileRouteRoute,
  } as any)
const AuthenticatedProfileSettingsRoute =
  AuthenticatedProfileSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedProfileRouteRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedOrgOrgIdIndexRoute =
  AuthenticatedOrgOrgIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdProductsRouteRoute =
  AuthenticatedOrgOrgIdProductsRouteRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthenticatedOrgOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdSettingsRouteRoute =
  AuthenticatedOrgOrgIdSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedOrgOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdTalentsRouteRoute =
  AuthenticatedOrgOrgIdTalentsRouteRouteImport.update({
    id: '/talents',
    path: '/talents',
    getParentRoute: () => AuthenticatedOrgOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdBillingIndexRoute =
  AuthenticatedOrgOrgIdBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => AuthenticatedOrgOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdProductsIndexRoute =
  AuthenticatedOrgOrgIdProductsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgOrgIdProductsRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdProductsProductIdRouteRoute =
  AuthenticatedOrgOrgIdProductsProductIdRouteRouteImport.update({
    id: '/$productId',
    path: '/$productId',
    getParentRoute: () => AuthenticatedOrgOrgIdProductsRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdSettingsBrandRoute =
  AuthenticatedOrgOrgIdSettingsBrandRouteImport.update({
    id: '/brand',
    path: '/brand',
    getParentRoute: () => AuthenticatedOrgOrgIdSettingsRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdSettingsGeneralRoute =
  AuthenticatedOrgOrgIdSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AuthenticatedOrgOrgIdSettingsRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdTalentsIndexRoute =
  AuthenticatedOrgOrgIdTalentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgOrgIdTalentsRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdTalentsTalentIdRouteRoute =
  AuthenticatedOrgOrgIdTalentsTalentIdRouteRouteImport.update({
    id: '/$talentId',
    path: '/$talentId',
    getParentRoute: () => AuthenticatedOrgOrgIdTalentsRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdUsageIndexRoute =
  AuthenticatedOrgOrgIdUsageIndexRouteImport.update({
    id: '/usage/',
    path: '/usage/',
    getParentRoute: () => AuthenticatedOrgOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdUsersIndexRoute =
  AuthenticatedOrgOrgIdUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AuthenticatedOrgOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRouteImport.update({
    id: '/workspace/$workspaceId',
    path: '/workspace/$workspaceId',
    getParentRoute: () => AuthenticatedOrgOrgIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdIndexRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRouteImport.update({
    id: '/bulk-jobs',
    path: '/bulk-jobs',
    getParentRoute: () => AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsRouteRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsRouteRouteImport.update({
    id: '/models',
    path: '/models',
    getParentRoute: () => AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesRouteRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesRouteRouteImport.update({
    id: '/nodes',
    path: '/nodes',
    getParentRoute: () => AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterRouteRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterRouteRouteImport.update({
    id: '/roster',
    path: '/roster',
    getParentRoute: () => AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesRouteRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesRouteRouteImport.update({
    id: '/scenes',
    path: '/scenes',
    getParentRoute: () => AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductRouteRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductRouteRouteImport.update(
    {
      id: '/sketch-to-product',
      path: '/sketch-to-product',
      getParentRoute: () => AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute,
    } as any,
  )
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoRouteRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoRouteRouteImport.update({
    id: '/video',
    path: '/video',
    getParentRoute: () => AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoRouteRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoRouteRouteImport.update({
    id: '/vto',
    path: '/vto',
    getParentRoute: () => AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsIndexRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsIndexRouteImport.update({
    id: '/assets/',
    path: '/assets/',
    getParentRoute: () => AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsAssetIdRouteRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsAssetIdRouteRouteImport.update(
    {
      id: '/assets/$assetId',
      path: '/assets/$assetId',
      getParentRoute: () => AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute,
    } as any,
  )
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsIndexRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsIndexRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsModelIdRouteRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsModelIdRouteRouteImport.update(
    {
      id: '/$modelId',
      path: '/$modelId',
      getParentRoute: () =>
        AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsRouteRoute,
    } as any,
  )
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesIndexRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesCanvasIdRouteRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesCanvasIdRouteRouteImport.update(
    {
      id: '/$canvasId',
      path: '/$canvasId',
      getParentRoute: () =>
        AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesRouteRoute,
    } as any,
  )
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterIndexRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterTalentIdRouteRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterTalentIdRouteRouteImport.update(
    {
      id: '/$talentId',
      path: '/$talentId',
      getParentRoute: () =>
        AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterRouteRoute,
    } as any,
  )
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesIndexRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesSceneIdRouteRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesSceneIdRouteRouteImport.update(
    {
      id: '/$sceneId',
      path: '/$sceneId',
      getParentRoute: () =>
        AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesRouteRoute,
    } as any,
  )
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsBrandRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsBrandRouteImport.update({
    id: '/brand',
    path: '/brand',
    getParentRoute: () =>
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsDeletionRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsDeletionRouteImport.update({
    id: '/deletion',
    path: '/deletion',
    getParentRoute: () =>
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsGeneralRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () =>
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsIntegrationsRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsIntegrationsRouteImport.update(
    {
      id: '/integrations',
      path: '/integrations',
      getParentRoute: () =>
        AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRoute,
    } as any,
  )
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsMembersRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () =>
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductIndexRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductRouteRoute,
    } as any,
  )
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductProductIdRouteRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductProductIdRouteRouteImport.update(
    {
      id: '/$productId',
      path: '/$productId',
      getParentRoute: () =>
        AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductRouteRoute,
    } as any,
  )
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoIndexRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoVideoIdRouteRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoVideoIdRouteRouteImport.update({
    id: '/$videoId',
    path: '/$videoId',
    getParentRoute: () =>
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoIndexRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoLookIdRouteRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoLookIdRouteRouteImport.update({
    id: '/$lookId',
    path: '/$lookId',
    getParentRoute: () =>
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoRouteRoute,
  } as any)
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsStpJobIdRouteRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsStpJobIdRouteRouteImport.update(
    {
      id: '/stp/$jobId',
      path: '/stp/$jobId',
      getParentRoute: () =>
        AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRoute,
    } as any,
  )
const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsVtoJobIdRouteRoute =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsVtoJobIdRouteRouteImport.update(
    {
      id: '/vto/$jobId',
      path: '/vto/$jobId',
      getParentRoute: () =>
        AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/profile': typeof AuthenticatedProfileRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/onboarding': typeof authOnboardingRoute
  '/reset-password': typeof authResetPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-up': typeof authSignUpRoute
  '/auth/accept-invite': typeof AuthAcceptInviteRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/invitation': typeof AuthInvitationRoute
  '/auth/mcp-callback': typeof AuthMcpCallbackRoute
  '/org/$orgId': typeof AuthenticatedOrgOrgIdRouteRouteWithChildren
  '/admin/banners': typeof AuthenticatedAdminBannersRoute
  '/admin/benchmarks': typeof AuthenticatedAdminBenchmarksRoute
  '/admin/billing': typeof AuthenticatedAdminBillingRoute
  '/admin/oauth-clients': typeof AuthenticatedAdminOauthClientsRoute
  '/admin/organizations': typeof AuthenticatedAdminOrganizationsRoute
  '/admin/plans': typeof AuthenticatedAdminPlansRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/e2e/media': typeof AuthenticatedE2eMediaRoute
  '/profile/connections': typeof AuthenticatedProfileConnectionsRoute
  '/profile/password': typeof AuthenticatedProfilePasswordRoute
  '/profile/settings': typeof AuthenticatedProfileSettingsRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/org/$orgId/products': typeof AuthenticatedOrgOrgIdProductsRouteRouteWithChildren
  '/org/$orgId/settings': typeof AuthenticatedOrgOrgIdSettingsRouteRouteWithChildren
  '/org/$orgId/talents': typeof AuthenticatedOrgOrgIdTalentsRouteRouteWithChildren
  '/org/$orgId/': typeof AuthenticatedOrgOrgIdIndexRoute
  '/org/$orgId/products/$productId': typeof AuthenticatedOrgOrgIdProductsProductIdRouteRoute
  '/org/$orgId/talents/$talentId': typeof AuthenticatedOrgOrgIdTalentsTalentIdRouteRoute
  '/org/$orgId/workspace/$workspaceId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRouteWithChildren
  '/org/$orgId/settings/brand': typeof AuthenticatedOrgOrgIdSettingsBrandRoute
  '/org/$orgId/settings/general': typeof AuthenticatedOrgOrgIdSettingsGeneralRoute
  '/org/$orgId/billing/': typeof AuthenticatedOrgOrgIdBillingIndexRoute
  '/org/$orgId/products/': typeof AuthenticatedOrgOrgIdProductsIndexRoute
  '/org/$orgId/talents/': typeof AuthenticatedOrgOrgIdTalentsIndexRoute
  '/org/$orgId/usage/': typeof AuthenticatedOrgOrgIdUsageIndexRoute
  '/org/$orgId/users/': typeof AuthenticatedOrgOrgIdUsersIndexRoute
  '/org/$orgId/workspace/$workspaceId/bulk-jobs': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRouteWithChildren
  '/org/$orgId/workspace/$workspaceId/models': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsRouteRouteWithChildren
  '/org/$orgId/workspace/$workspaceId/nodes': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesRouteRouteWithChildren
  '/org/$orgId/workspace/$workspaceId/roster': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterRouteRouteWithChildren
  '/org/$orgId/workspace/$workspaceId/scenes': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesRouteRouteWithChildren
  '/org/$orgId/workspace/$workspaceId/settings': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRouteWithChildren
  '/org/$orgId/workspace/$workspaceId/sketch-to-product': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductRouteRouteWithChildren
  '/org/$orgId/workspace/$workspaceId/video': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoRouteRouteWithChildren
  '/org/$orgId/workspace/$workspaceId/vto': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoRouteRouteWithChildren
  '/org/$orgId/workspace/$workspaceId/': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdIndexRoute
  '/org/$orgId/workspace/$workspaceId/assets/$assetId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsAssetIdRouteRoute
  '/org/$orgId/workspace/$workspaceId/models/$modelId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsModelIdRouteRoute
  '/org/$orgId/workspace/$workspaceId/nodes/$canvasId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesCanvasIdRouteRoute
  '/org/$orgId/workspace/$workspaceId/roster/$talentId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterTalentIdRouteRoute
  '/org/$orgId/workspace/$workspaceId/scenes/$sceneId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesSceneIdRouteRoute
  '/org/$orgId/workspace/$workspaceId/sketch-to-product/$productId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductProductIdRouteRoute
  '/org/$orgId/workspace/$workspaceId/video/$videoId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoVideoIdRouteRoute
  '/org/$orgId/workspace/$workspaceId/vto/$lookId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoLookIdRouteRoute
  '/org/$orgId/workspace/$workspaceId/settings/brand': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsBrandRoute
  '/org/$orgId/workspace/$workspaceId/settings/deletion': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsDeletionRoute
  '/org/$orgId/workspace/$workspaceId/settings/general': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsGeneralRoute
  '/org/$orgId/workspace/$workspaceId/settings/integrations': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsIntegrationsRoute
  '/org/$orgId/workspace/$workspaceId/settings/members': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsMembersRoute
  '/org/$orgId/workspace/$workspaceId/assets/': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsIndexRoute
  '/org/$orgId/workspace/$workspaceId/bulk-jobs/': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsIndexRoute
  '/org/$orgId/workspace/$workspaceId/models/': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsIndexRoute
  '/org/$orgId/workspace/$workspaceId/nodes/': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesIndexRoute
  '/org/$orgId/workspace/$workspaceId/roster/': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterIndexRoute
  '/org/$orgId/workspace/$workspaceId/scenes/': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesIndexRoute
  '/org/$orgId/workspace/$workspaceId/sketch-to-product/': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductIndexRoute
  '/org/$orgId/workspace/$workspaceId/video/': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoIndexRoute
  '/org/$orgId/workspace/$workspaceId/vto/': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoIndexRoute
  '/org/$orgId/workspace/$workspaceId/bulk-jobs/stp/$jobId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsStpJobIdRouteRoute
  '/org/$orgId/workspace/$workspaceId/bulk-jobs/vto/$jobId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsVtoJobIdRouteRoute
}
export interface FileRoutesByTo {
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/profile': typeof AuthenticatedProfileRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/onboarding': typeof authOnboardingRoute
  '/reset-password': typeof authResetPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-up': typeof authSignUpRoute
  '/auth/accept-invite': typeof AuthAcceptInviteRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/invitation': typeof AuthInvitationRoute
  '/auth/mcp-callback': typeof AuthMcpCallbackRoute
  '/': typeof AuthenticatedIndexRoute
  '/admin/banners': typeof AuthenticatedAdminBannersRoute
  '/admin/benchmarks': typeof AuthenticatedAdminBenchmarksRoute
  '/admin/billing': typeof AuthenticatedAdminBillingRoute
  '/admin/oauth-clients': typeof AuthenticatedAdminOauthClientsRoute
  '/admin/organizations': typeof AuthenticatedAdminOrganizationsRoute
  '/admin/plans': typeof AuthenticatedAdminPlansRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/e2e/media': typeof AuthenticatedE2eMediaRoute
  '/profile/connections': typeof AuthenticatedProfileConnectionsRoute
  '/profile/password': typeof AuthenticatedProfilePasswordRoute
  '/profile/settings': typeof AuthenticatedProfileSettingsRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/org/$orgId/settings': typeof AuthenticatedOrgOrgIdSettingsRouteRouteWithChildren
  '/org/$orgId': typeof AuthenticatedOrgOrgIdIndexRoute
  '/org/$orgId/products/$productId': typeof AuthenticatedOrgOrgIdProductsProductIdRouteRoute
  '/org/$orgId/talents/$talentId': typeof AuthenticatedOrgOrgIdTalentsTalentIdRouteRoute
  '/org/$orgId/settings/brand': typeof AuthenticatedOrgOrgIdSettingsBrandRoute
  '/org/$orgId/settings/general': typeof AuthenticatedOrgOrgIdSettingsGeneralRoute
  '/org/$orgId/billing': typeof AuthenticatedOrgOrgIdBillingIndexRoute
  '/org/$orgId/products': typeof AuthenticatedOrgOrgIdProductsIndexRoute
  '/org/$orgId/talents': typeof AuthenticatedOrgOrgIdTalentsIndexRoute
  '/org/$orgId/usage': typeof AuthenticatedOrgOrgIdUsageIndexRoute
  '/org/$orgId/users': typeof AuthenticatedOrgOrgIdUsersIndexRoute
  '/org/$orgId/workspace/$workspaceId/settings': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRouteWithChildren
  '/org/$orgId/workspace/$workspaceId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdIndexRoute
  '/org/$orgId/workspace/$workspaceId/assets/$assetId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsAssetIdRouteRoute
  '/org/$orgId/workspace/$workspaceId/models/$modelId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsModelIdRouteRoute
  '/org/$orgId/workspace/$workspaceId/nodes/$canvasId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesCanvasIdRouteRoute
  '/org/$orgId/workspace/$workspaceId/roster/$talentId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterTalentIdRouteRoute
  '/org/$orgId/workspace/$workspaceId/scenes/$sceneId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesSceneIdRouteRoute
  '/org/$orgId/workspace/$workspaceId/sketch-to-product/$productId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductProductIdRouteRoute
  '/org/$orgId/workspace/$workspaceId/video/$videoId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoVideoIdRouteRoute
  '/org/$orgId/workspace/$workspaceId/vto/$lookId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoLookIdRouteRoute
  '/org/$orgId/workspace/$workspaceId/settings/brand': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsBrandRoute
  '/org/$orgId/workspace/$workspaceId/settings/deletion': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsDeletionRoute
  '/org/$orgId/workspace/$workspaceId/settings/general': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsGeneralRoute
  '/org/$orgId/workspace/$workspaceId/settings/integrations': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsIntegrationsRoute
  '/org/$orgId/workspace/$workspaceId/settings/members': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsMembersRoute
  '/org/$orgId/workspace/$workspaceId/assets': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsIndexRoute
  '/org/$orgId/workspace/$workspaceId/bulk-jobs': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsIndexRoute
  '/org/$orgId/workspace/$workspaceId/models': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsIndexRoute
  '/org/$orgId/workspace/$workspaceId/nodes': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesIndexRoute
  '/org/$orgId/workspace/$workspaceId/roster': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterIndexRoute
  '/org/$orgId/workspace/$workspaceId/scenes': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesIndexRoute
  '/org/$orgId/workspace/$workspaceId/sketch-to-product': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductIndexRoute
  '/org/$orgId/workspace/$workspaceId/video': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoIndexRoute
  '/org/$orgId/workspace/$workspaceId/vto': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoIndexRoute
  '/org/$orgId/workspace/$workspaceId/bulk-jobs/stp/$jobId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsStpJobIdRouteRoute
  '/org/$orgId/workspace/$workspaceId/bulk-jobs/vto/$jobId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsVtoJobIdRouteRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(auth)': typeof authRouteRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/_authenticated/profile': typeof AuthenticatedProfileRouteRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/onboarding': typeof authOnboardingRoute
  '/(auth)/reset-password': typeof authResetPasswordRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/sign-up': typeof authSignUpRoute
  '/auth/accept-invite': typeof AuthAcceptInviteRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/invitation': typeof AuthInvitationRoute
  '/auth/mcp-callback': typeof AuthMcpCallbackRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/org/$orgId': typeof AuthenticatedOrgOrgIdRouteRouteWithChildren
  '/_authenticated/admin/banners': typeof AuthenticatedAdminBannersRoute
  '/_authenticated/admin/benchmarks': typeof AuthenticatedAdminBenchmarksRoute
  '/_authenticated/admin/billing': typeof AuthenticatedAdminBillingRoute
  '/_authenticated/admin/oauth-clients': typeof AuthenticatedAdminOauthClientsRoute
  '/_authenticated/admin/organizations': typeof AuthenticatedAdminOrganizationsRoute
  '/_authenticated/admin/plans': typeof AuthenticatedAdminPlansRoute
  '/_authenticated/admin/users': typeof AuthenticatedAdminUsersRoute
  '/_authenticated/e2e/media': typeof AuthenticatedE2eMediaRoute
  '/_authenticated/profile/connections': typeof AuthenticatedProfileConnectionsRoute
  '/_authenticated/profile/password': typeof AuthenticatedProfilePasswordRoute
  '/_authenticated/profile/settings': typeof AuthenticatedProfileSettingsRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/org/$orgId/products': typeof AuthenticatedOrgOrgIdProductsRouteRouteWithChildren
  '/_authenticated/org/$orgId/settings': typeof AuthenticatedOrgOrgIdSettingsRouteRouteWithChildren
  '/_authenticated/org/$orgId/talents': typeof AuthenticatedOrgOrgIdTalentsRouteRouteWithChildren
  '/_authenticated/org/$orgId/': typeof AuthenticatedOrgOrgIdIndexRoute
  '/_authenticated/org/$orgId/products/$productId': typeof AuthenticatedOrgOrgIdProductsProductIdRouteRoute
  '/_authenticated/org/$orgId/talents/$talentId': typeof AuthenticatedOrgOrgIdTalentsTalentIdRouteRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRouteWithChildren
  '/_authenticated/org/$orgId/settings/brand': typeof AuthenticatedOrgOrgIdSettingsBrandRoute
  '/_authenticated/org/$orgId/settings/general': typeof AuthenticatedOrgOrgIdSettingsGeneralRoute
  '/_authenticated/org/$orgId/billing/': typeof AuthenticatedOrgOrgIdBillingIndexRoute
  '/_authenticated/org/$orgId/products/': typeof AuthenticatedOrgOrgIdProductsIndexRoute
  '/_authenticated/org/$orgId/talents/': typeof AuthenticatedOrgOrgIdTalentsIndexRoute
  '/_authenticated/org/$orgId/usage/': typeof AuthenticatedOrgOrgIdUsageIndexRoute
  '/_authenticated/org/$orgId/users/': typeof AuthenticatedOrgOrgIdUsersIndexRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/bulk-jobs': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRouteWithChildren
  '/_authenticated/org/$orgId/workspace/$workspaceId/models': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsRouteRouteWithChildren
  '/_authenticated/org/$orgId/workspace/$workspaceId/nodes': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesRouteRouteWithChildren
  '/_authenticated/org/$orgId/workspace/$workspaceId/roster': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterRouteRouteWithChildren
  '/_authenticated/org/$orgId/workspace/$workspaceId/scenes': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesRouteRouteWithChildren
  '/_authenticated/org/$orgId/workspace/$workspaceId/settings': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRouteWithChildren
  '/_authenticated/org/$orgId/workspace/$workspaceId/sketch-to-product': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductRouteRouteWithChildren
  '/_authenticated/org/$orgId/workspace/$workspaceId/video': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoRouteRouteWithChildren
  '/_authenticated/org/$orgId/workspace/$workspaceId/vto': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoRouteRouteWithChildren
  '/_authenticated/org/$orgId/workspace/$workspaceId/': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdIndexRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/assets/$assetId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsAssetIdRouteRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/models/$modelId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsModelIdRouteRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/nodes/$canvasId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesCanvasIdRouteRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/roster/$talentId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterTalentIdRouteRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/scenes/$sceneId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesSceneIdRouteRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/sketch-to-product/$productId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductProductIdRouteRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/video/$videoId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoVideoIdRouteRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/vto/$lookId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoLookIdRouteRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/settings/brand': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsBrandRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/settings/deletion': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsDeletionRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/settings/general': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsGeneralRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/settings/integrations': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsIntegrationsRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/settings/members': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsMembersRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/assets/': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsIndexRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/bulk-jobs/': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsIndexRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/models/': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsIndexRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/nodes/': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesIndexRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/roster/': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterIndexRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/scenes/': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesIndexRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/sketch-to-product/': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductIndexRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/video/': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoIndexRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/vto/': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoIndexRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/bulk-jobs/stp/$jobId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsStpJobIdRouteRoute
  '/_authenticated/org/$orgId/workspace/$workspaceId/bulk-jobs/vto/$jobId': typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsVtoJobIdRouteRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/privacy-policy'
    | '/terms-of-service'
    | '/admin'
    | '/profile'
    | '/forgot-password'
    | '/onboarding'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/auth/accept-invite'
    | '/auth/callback'
    | '/auth/invitation'
    | '/auth/mcp-callback'
    | '/org/$orgId'
    | '/admin/banners'
    | '/admin/benchmarks'
    | '/admin/billing'
    | '/admin/oauth-clients'
    | '/admin/organizations'
    | '/admin/plans'
    | '/admin/users'
    | '/e2e/media'
    | '/profile/connections'
    | '/profile/password'
    | '/profile/settings'
    | '/admin/'
    | '/users/'
    | '/org/$orgId/products'
    | '/org/$orgId/settings'
    | '/org/$orgId/talents'
    | '/org/$orgId/'
    | '/org/$orgId/products/$productId'
    | '/org/$orgId/talents/$talentId'
    | '/org/$orgId/workspace/$workspaceId'
    | '/org/$orgId/settings/brand'
    | '/org/$orgId/settings/general'
    | '/org/$orgId/billing/'
    | '/org/$orgId/products/'
    | '/org/$orgId/talents/'
    | '/org/$orgId/usage/'
    | '/org/$orgId/users/'
    | '/org/$orgId/workspace/$workspaceId/bulk-jobs'
    | '/org/$orgId/workspace/$workspaceId/models'
    | '/org/$orgId/workspace/$workspaceId/nodes'
    | '/org/$orgId/workspace/$workspaceId/roster'
    | '/org/$orgId/workspace/$workspaceId/scenes'
    | '/org/$orgId/workspace/$workspaceId/settings'
    | '/org/$orgId/workspace/$workspaceId/sketch-to-product'
    | '/org/$orgId/workspace/$workspaceId/video'
    | '/org/$orgId/workspace/$workspaceId/vto'
    | '/org/$orgId/workspace/$workspaceId/'
    | '/org/$orgId/workspace/$workspaceId/assets/$assetId'
    | '/org/$orgId/workspace/$workspaceId/models/$modelId'
    | '/org/$orgId/workspace/$workspaceId/nodes/$canvasId'
    | '/org/$orgId/workspace/$workspaceId/roster/$talentId'
    | '/org/$orgId/workspace/$workspaceId/scenes/$sceneId'
    | '/org/$orgId/workspace/$workspaceId/sketch-to-product/$productId'
    | '/org/$orgId/workspace/$workspaceId/video/$videoId'
    | '/org/$orgId/workspace/$workspaceId/vto/$lookId'
    | '/org/$orgId/workspace/$workspaceId/settings/brand'
    | '/org/$orgId/workspace/$workspaceId/settings/deletion'
    | '/org/$orgId/workspace/$workspaceId/settings/general'
    | '/org/$orgId/workspace/$workspaceId/settings/integrations'
    | '/org/$orgId/workspace/$workspaceId/settings/members'
    | '/org/$orgId/workspace/$workspaceId/assets/'
    | '/org/$orgId/workspace/$workspaceId/bulk-jobs/'
    | '/org/$orgId/workspace/$workspaceId/models/'
    | '/org/$orgId/workspace/$workspaceId/nodes/'
    | '/org/$orgId/workspace/$workspaceId/roster/'
    | '/org/$orgId/workspace/$workspaceId/scenes/'
    | '/org/$orgId/workspace/$workspaceId/sketch-to-product/'
    | '/org/$orgId/workspace/$workspaceId/video/'
    | '/org/$orgId/workspace/$workspaceId/vto/'
    | '/org/$orgId/workspace/$workspaceId/bulk-jobs/stp/$jobId'
    | '/org/$orgId/workspace/$workspaceId/bulk-jobs/vto/$jobId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/privacy-policy'
    | '/terms-of-service'
    | '/profile'
    | '/forgot-password'
    | '/onboarding'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/auth/accept-invite'
    | '/auth/callback'
    | '/auth/invitation'
    | '/auth/mcp-callback'
    | '/'
    | '/admin/banners'
    | '/admin/benchmarks'
    | '/admin/billing'
    | '/admin/oauth-clients'
    | '/admin/organizations'
    | '/admin/plans'
    | '/admin/users'
    | '/e2e/media'
    | '/profile/connections'
    | '/profile/password'
    | '/profile/settings'
    | '/admin'
    | '/users'
    | '/org/$orgId/settings'
    | '/org/$orgId'
    | '/org/$orgId/products/$productId'
    | '/org/$orgId/talents/$talentId'
    | '/org/$orgId/settings/brand'
    | '/org/$orgId/settings/general'
    | '/org/$orgId/billing'
    | '/org/$orgId/products'
    | '/org/$orgId/talents'
    | '/org/$orgId/usage'
    | '/org/$orgId/users'
    | '/org/$orgId/workspace/$workspaceId/settings'
    | '/org/$orgId/workspace/$workspaceId'
    | '/org/$orgId/workspace/$workspaceId/assets/$assetId'
    | '/org/$orgId/workspace/$workspaceId/models/$modelId'
    | '/org/$orgId/workspace/$workspaceId/nodes/$canvasId'
    | '/org/$orgId/workspace/$workspaceId/roster/$talentId'
    | '/org/$orgId/workspace/$workspaceId/scenes/$sceneId'
    | '/org/$orgId/workspace/$workspaceId/sketch-to-product/$productId'
    | '/org/$orgId/workspace/$workspaceId/video/$videoId'
    | '/org/$orgId/workspace/$workspaceId/vto/$lookId'
    | '/org/$orgId/workspace/$workspaceId/settings/brand'
    | '/org/$orgId/workspace/$workspaceId/settings/deletion'
    | '/org/$orgId/workspace/$workspaceId/settings/general'
    | '/org/$orgId/workspace/$workspaceId/settings/integrations'
    | '/org/$orgId/workspace/$workspaceId/settings/members'
    | '/org/$orgId/workspace/$workspaceId/assets'
    | '/org/$orgId/workspace/$workspaceId/bulk-jobs'
    | '/org/$orgId/workspace/$workspaceId/models'
    | '/org/$orgId/workspace/$workspaceId/nodes'
    | '/org/$orgId/workspace/$workspaceId/roster'
    | '/org/$orgId/workspace/$workspaceId/scenes'
    | '/org/$orgId/workspace/$workspaceId/sketch-to-product'
    | '/org/$orgId/workspace/$workspaceId/video'
    | '/org/$orgId/workspace/$workspaceId/vto'
    | '/org/$orgId/workspace/$workspaceId/bulk-jobs/stp/$jobId'
    | '/org/$orgId/workspace/$workspaceId/bulk-jobs/vto/$jobId'
  id:
    | '__root__'
    | '/(auth)'
    | '/_authenticated'
    | '/privacy-policy'
    | '/terms-of-service'
    | '/_authenticated/admin'
    | '/_authenticated/profile'
    | '/(auth)/forgot-password'
    | '/(auth)/onboarding'
    | '/(auth)/reset-password'
    | '/(auth)/sign-in'
    | '/(auth)/sign-up'
    | '/auth/accept-invite'
    | '/auth/callback'
    | '/auth/invitation'
    | '/auth/mcp-callback'
    | '/_authenticated/'
    | '/_authenticated/org/$orgId'
    | '/_authenticated/admin/banners'
    | '/_authenticated/admin/benchmarks'
    | '/_authenticated/admin/billing'
    | '/_authenticated/admin/oauth-clients'
    | '/_authenticated/admin/organizations'
    | '/_authenticated/admin/plans'
    | '/_authenticated/admin/users'
    | '/_authenticated/e2e/media'
    | '/_authenticated/profile/connections'
    | '/_authenticated/profile/password'
    | '/_authenticated/profile/settings'
    | '/_authenticated/admin/'
    | '/_authenticated/users/'
    | '/_authenticated/org/$orgId/products'
    | '/_authenticated/org/$orgId/settings'
    | '/_authenticated/org/$orgId/talents'
    | '/_authenticated/org/$orgId/'
    | '/_authenticated/org/$orgId/products/$productId'
    | '/_authenticated/org/$orgId/talents/$talentId'
    | '/_authenticated/org/$orgId/workspace/$workspaceId'
    | '/_authenticated/org/$orgId/settings/brand'
    | '/_authenticated/org/$orgId/settings/general'
    | '/_authenticated/org/$orgId/billing/'
    | '/_authenticated/org/$orgId/products/'
    | '/_authenticated/org/$orgId/talents/'
    | '/_authenticated/org/$orgId/usage/'
    | '/_authenticated/org/$orgId/users/'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/bulk-jobs'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/models'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/nodes'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/roster'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/scenes'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/settings'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/sketch-to-product'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/video'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/vto'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/assets/$assetId'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/models/$modelId'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/nodes/$canvasId'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/roster/$talentId'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/scenes/$sceneId'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/sketch-to-product/$productId'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/video/$videoId'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/vto/$lookId'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/settings/brand'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/settings/deletion'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/settings/general'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/settings/integrations'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/settings/members'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/assets/'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/bulk-jobs/'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/models/'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/nodes/'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/roster/'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/scenes/'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/sketch-to-product/'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/video/'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/vto/'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/bulk-jobs/stp/$jobId'
    | '/_authenticated/org/$orgId/workspace/$workspaceId/bulk-jobs/vto/$jobId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  authRouteRoute: typeof authRouteRouteWithChildren
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  TermsOfServiceRoute: typeof TermsOfServiceRoute
  AuthAcceptInviteRoute: typeof AuthAcceptInviteRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthInvitationRoute: typeof AuthInvitationRoute
  AuthMcpCallbackRoute: typeof AuthMcpCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(auth)': {
      id: '/(auth)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/onboarding': {
      id: '/(auth)/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof authOnboardingRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/auth/accept-invite': {
      id: '/auth/accept-invite'
      path: '/auth/accept-invite'
      fullPath: '/auth/accept-invite'
      preLoaderRoute: typeof AuthAcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/invitation': {
      id: '/auth/invitation'
      path: '/auth/invitation'
      fullPath: '/auth/invitation'
      preLoaderRoute: typeof AuthInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/mcp-callback': {
      id: '/auth/mcp-callback'
      path: '/auth/mcp-callback'
      fullPath: '/auth/mcp-callback'
      preLoaderRoute: typeof AuthMcpCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/banners': {
      id: '/_authenticated/admin/banners'
      path: '/banners'
      fullPath: '/admin/banners'
      preLoaderRoute: typeof AuthenticatedAdminBannersRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/benchmarks': {
      id: '/_authenticated/admin/benchmarks'
      path: '/benchmarks'
      fullPath: '/admin/benchmarks'
      preLoaderRoute: typeof AuthenticatedAdminBenchmarksRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/billing': {
      id: '/_authenticated/admin/billing'
      path: '/billing'
      fullPath: '/admin/billing'
      preLoaderRoute: typeof AuthenticatedAdminBillingRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/oauth-clients': {
      id: '/_authenticated/admin/oauth-clients'
      path: '/oauth-clients'
      fullPath: '/admin/oauth-clients'
      preLoaderRoute: typeof AuthenticatedAdminOauthClientsRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/organizations': {
      id: '/_authenticated/admin/organizations'
      path: '/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/plans': {
      id: '/_authenticated/admin/plans'
      path: '/plans'
      fullPath: '/admin/plans'
      preLoaderRoute: typeof AuthenticatedAdminPlansRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/users': {
      id: '/_authenticated/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthenticatedAdminUsersRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/e2e/media': {
      id: '/_authenticated/e2e/media'
      path: '/e2e/media'
      fullPath: '/e2e/media'
      preLoaderRoute: typeof AuthenticatedE2eMediaRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/org/$orgId': {
      id: '/_authenticated/org/$orgId'
      path: '/org/$orgId'
      fullPath: '/org/$orgId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/profile/connections': {
      id: '/_authenticated/profile/connections'
      path: '/connections'
      fullPath: '/profile/connections'
      preLoaderRoute: typeof AuthenticatedProfileConnectionsRouteImport
      parentRoute: typeof AuthenticatedProfileRouteRoute
    }
    '/_authenticated/profile/password': {
      id: '/_authenticated/profile/password'
      path: '/password'
      fullPath: '/profile/password'
      preLoaderRoute: typeof AuthenticatedProfilePasswordRouteImport
      parentRoute: typeof AuthenticatedProfileRouteRoute
    }
    '/_authenticated/profile/settings': {
      id: '/_authenticated/profile/settings'
      path: '/settings'
      fullPath: '/profile/settings'
      preLoaderRoute: typeof AuthenticatedProfileSettingsRouteImport
      parentRoute: typeof AuthenticatedProfileRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/org/$orgId/': {
      id: '/_authenticated/org/$orgId/'
      path: '/'
      fullPath: '/org/$orgId/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRouteRoute
    }
    '/_authenticated/org/$orgId/products': {
      id: '/_authenticated/org/$orgId/products'
      path: '/products'
      fullPath: '/org/$orgId/products'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProductsRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRouteRoute
    }
    '/_authenticated/org/$orgId/settings': {
      id: '/_authenticated/org/$orgId/settings'
      path: '/settings'
      fullPath: '/org/$orgId/settings'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRouteRoute
    }
    '/_authenticated/org/$orgId/talents': {
      id: '/_authenticated/org/$orgId/talents'
      path: '/talents'
      fullPath: '/org/$orgId/talents'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdTalentsRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRouteRoute
    }
    '/_authenticated/org/$orgId/billing/': {
      id: '/_authenticated/org/$orgId/billing/'
      path: '/billing'
      fullPath: '/org/$orgId/billing/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdBillingIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRouteRoute
    }
    '/_authenticated/org/$orgId/products/': {
      id: '/_authenticated/org/$orgId/products/'
      path: '/'
      fullPath: '/org/$orgId/products/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProductsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdProductsRouteRoute
    }
    '/_authenticated/org/$orgId/products/$productId': {
      id: '/_authenticated/org/$orgId/products/$productId'
      path: '/$productId'
      fullPath: '/org/$orgId/products/$productId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProductsProductIdRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdProductsRouteRoute
    }
    '/_authenticated/org/$orgId/settings/brand': {
      id: '/_authenticated/org/$orgId/settings/brand'
      path: '/brand'
      fullPath: '/org/$orgId/settings/brand'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdSettingsBrandRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdSettingsRouteRoute
    }
    '/_authenticated/org/$orgId/settings/general': {
      id: '/_authenticated/org/$orgId/settings/general'
      path: '/general'
      fullPath: '/org/$orgId/settings/general'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdSettingsGeneralRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdSettingsRouteRoute
    }
    '/_authenticated/org/$orgId/talents/': {
      id: '/_authenticated/org/$orgId/talents/'
      path: '/'
      fullPath: '/org/$orgId/talents/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdTalentsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdTalentsRouteRoute
    }
    '/_authenticated/org/$orgId/talents/$talentId': {
      id: '/_authenticated/org/$orgId/talents/$talentId'
      path: '/$talentId'
      fullPath: '/org/$orgId/talents/$talentId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdTalentsTalentIdRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdTalentsRouteRoute
    }
    '/_authenticated/org/$orgId/usage/': {
      id: '/_authenticated/org/$orgId/usage/'
      path: '/usage'
      fullPath: '/org/$orgId/usage/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdUsageIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRouteRoute
    }
    '/_authenticated/org/$orgId/users/': {
      id: '/_authenticated/org/$orgId/users/'
      path: '/users'
      fullPath: '/org/$orgId/users/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdUsersIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId'
      path: '/workspace/$workspaceId'
      fullPath: '/org/$orgId/workspace/$workspaceId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/'
      path: '/'
      fullPath: '/org/$orgId/workspace/$workspaceId/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/bulk-jobs': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/bulk-jobs'
      path: '/bulk-jobs'
      fullPath: '/org/$orgId/workspace/$workspaceId/bulk-jobs'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/models': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/models'
      path: '/models'
      fullPath: '/org/$orgId/workspace/$workspaceId/models'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/nodes': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/nodes'
      path: '/nodes'
      fullPath: '/org/$orgId/workspace/$workspaceId/nodes'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/roster': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/roster'
      path: '/roster'
      fullPath: '/org/$orgId/workspace/$workspaceId/roster'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/scenes': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/scenes'
      path: '/scenes'
      fullPath: '/org/$orgId/workspace/$workspaceId/scenes'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/settings': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/settings'
      path: '/settings'
      fullPath: '/org/$orgId/workspace/$workspaceId/settings'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/sketch-to-product': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/sketch-to-product'
      path: '/sketch-to-product'
      fullPath: '/org/$orgId/workspace/$workspaceId/sketch-to-product'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/video': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/video'
      path: '/video'
      fullPath: '/org/$orgId/workspace/$workspaceId/video'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/vto': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/vto'
      path: '/vto'
      fullPath: '/org/$orgId/workspace/$workspaceId/vto'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/assets/': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/assets/'
      path: '/assets'
      fullPath: '/org/$orgId/workspace/$workspaceId/assets/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/assets/$assetId': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/assets/$assetId'
      path: '/assets/$assetId'
      fullPath: '/org/$orgId/workspace/$workspaceId/assets/$assetId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsAssetIdRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/bulk-jobs/': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/bulk-jobs/'
      path: '/'
      fullPath: '/org/$orgId/workspace/$workspaceId/bulk-jobs/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/models/': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/models/'
      path: '/'
      fullPath: '/org/$orgId/workspace/$workspaceId/models/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/models/$modelId': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/models/$modelId'
      path: '/$modelId'
      fullPath: '/org/$orgId/workspace/$workspaceId/models/$modelId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsModelIdRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/nodes/': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/nodes/'
      path: '/'
      fullPath: '/org/$orgId/workspace/$workspaceId/nodes/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/nodes/$canvasId': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/nodes/$canvasId'
      path: '/$canvasId'
      fullPath: '/org/$orgId/workspace/$workspaceId/nodes/$canvasId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesCanvasIdRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/roster/': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/roster/'
      path: '/'
      fullPath: '/org/$orgId/workspace/$workspaceId/roster/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/roster/$talentId': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/roster/$talentId'
      path: '/$talentId'
      fullPath: '/org/$orgId/workspace/$workspaceId/roster/$talentId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterTalentIdRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/scenes/': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/scenes/'
      path: '/'
      fullPath: '/org/$orgId/workspace/$workspaceId/scenes/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/scenes/$sceneId': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/scenes/$sceneId'
      path: '/$sceneId'
      fullPath: '/org/$orgId/workspace/$workspaceId/scenes/$sceneId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesSceneIdRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/settings/brand': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/settings/brand'
      path: '/brand'
      fullPath: '/org/$orgId/workspace/$workspaceId/settings/brand'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsBrandRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/settings/deletion': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/settings/deletion'
      path: '/deletion'
      fullPath: '/org/$orgId/workspace/$workspaceId/settings/deletion'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsDeletionRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/settings/general': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/settings/general'
      path: '/general'
      fullPath: '/org/$orgId/workspace/$workspaceId/settings/general'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsGeneralRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/settings/integrations': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/settings/integrations'
      path: '/integrations'
      fullPath: '/org/$orgId/workspace/$workspaceId/settings/integrations'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsIntegrationsRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/settings/members': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/settings/members'
      path: '/members'
      fullPath: '/org/$orgId/workspace/$workspaceId/settings/members'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsMembersRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/sketch-to-product/': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/sketch-to-product/'
      path: '/'
      fullPath: '/org/$orgId/workspace/$workspaceId/sketch-to-product/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/sketch-to-product/$productId': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/sketch-to-product/$productId'
      path: '/$productId'
      fullPath: '/org/$orgId/workspace/$workspaceId/sketch-to-product/$productId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductProductIdRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/video/': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/video/'
      path: '/'
      fullPath: '/org/$orgId/workspace/$workspaceId/video/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/video/$videoId': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/video/$videoId'
      path: '/$videoId'
      fullPath: '/org/$orgId/workspace/$workspaceId/video/$videoId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoVideoIdRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/vto/': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/vto/'
      path: '/'
      fullPath: '/org/$orgId/workspace/$workspaceId/vto/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/vto/$lookId': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/vto/$lookId'
      path: '/$lookId'
      fullPath: '/org/$orgId/workspace/$workspaceId/vto/$lookId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoLookIdRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/bulk-jobs/stp/$jobId': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/bulk-jobs/stp/$jobId'
      path: '/stp/$jobId'
      fullPath: '/org/$orgId/workspace/$workspaceId/bulk-jobs/stp/$jobId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsStpJobIdRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRoute
    }
    '/_authenticated/org/$orgId/workspace/$workspaceId/bulk-jobs/vto/$jobId': {
      id: '/_authenticated/org/$orgId/workspace/$workspaceId/bulk-jobs/vto/$jobId'
      path: '/vto/$jobId'
      fullPath: '/org/$orgId/workspace/$workspaceId/bulk-jobs/vto/$jobId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsVtoJobIdRouteRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRoute
    }
  }
}

interface authRouteRouteChildren {
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authOnboardingRoute: typeof authOnboardingRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  authSignInRoute: typeof authSignInRoute
  authSignUpRoute: typeof authSignUpRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authForgotPasswordRoute: authForgotPasswordRoute,
  authOnboardingRoute: authOnboardingRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authSignInRoute: authSignInRoute,
  authSignUpRoute: authSignUpRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

interface AuthenticatedAdminRouteRouteChildren {
  AuthenticatedAdminBannersRoute: typeof AuthenticatedAdminBannersRoute
  AuthenticatedAdminBenchmarksRoute: typeof AuthenticatedAdminBenchmarksRoute
  AuthenticatedAdminBillingRoute: typeof AuthenticatedAdminBillingRoute
  AuthenticatedAdminOauthClientsRoute: typeof AuthenticatedAdminOauthClientsRoute
  AuthenticatedAdminOrganizationsRoute: typeof AuthenticatedAdminOrganizationsRoute
  AuthenticatedAdminPlansRoute: typeof AuthenticatedAdminPlansRoute
  AuthenticatedAdminUsersRoute: typeof AuthenticatedAdminUsersRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteRouteChildren: AuthenticatedAdminRouteRouteChildren =
  {
    AuthenticatedAdminBannersRoute: AuthenticatedAdminBannersRoute,
    AuthenticatedAdminBenchmarksRoute: AuthenticatedAdminBenchmarksRoute,
    AuthenticatedAdminBillingRoute: AuthenticatedAdminBillingRoute,
    AuthenticatedAdminOauthClientsRoute: AuthenticatedAdminOauthClientsRoute,
    AuthenticatedAdminOrganizationsRoute: AuthenticatedAdminOrganizationsRoute,
    AuthenticatedAdminPlansRoute: AuthenticatedAdminPlansRoute,
    AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,
    AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
  }

const AuthenticatedAdminRouteRouteWithChildren =
  AuthenticatedAdminRouteRoute._addFileChildren(
    AuthenticatedAdminRouteRouteChildren,
  )

interface AuthenticatedProfileRouteRouteChildren {
  AuthenticatedProfileConnectionsRoute: typeof AuthenticatedProfileConnectionsRoute
  AuthenticatedProfilePasswordRoute: typeof AuthenticatedProfilePasswordRoute
  AuthenticatedProfileSettingsRoute: typeof AuthenticatedProfileSettingsRoute
}

const AuthenticatedProfileRouteRouteChildren: AuthenticatedProfileRouteRouteChildren =
  {
    AuthenticatedProfileConnectionsRoute: AuthenticatedProfileConnectionsRoute,
    AuthenticatedProfilePasswordRoute: AuthenticatedProfilePasswordRoute,
    AuthenticatedProfileSettingsRoute: AuthenticatedProfileSettingsRoute,
  }

const AuthenticatedProfileRouteRouteWithChildren =
  AuthenticatedProfileRouteRoute._addFileChildren(
    AuthenticatedProfileRouteRouteChildren,
  )

interface AuthenticatedOrgOrgIdProductsRouteRouteChildren {
  AuthenticatedOrgOrgIdProductsProductIdRouteRoute: typeof AuthenticatedOrgOrgIdProductsProductIdRouteRoute
  AuthenticatedOrgOrgIdProductsIndexRoute: typeof AuthenticatedOrgOrgIdProductsIndexRoute
}

const AuthenticatedOrgOrgIdProductsRouteRouteChildren: AuthenticatedOrgOrgIdProductsRouteRouteChildren =
  {
    AuthenticatedOrgOrgIdProductsProductIdRouteRoute:
      AuthenticatedOrgOrgIdProductsProductIdRouteRoute,
    AuthenticatedOrgOrgIdProductsIndexRoute:
      AuthenticatedOrgOrgIdProductsIndexRoute,
  }

const AuthenticatedOrgOrgIdProductsRouteRouteWithChildren =
  AuthenticatedOrgOrgIdProductsRouteRoute._addFileChildren(
    AuthenticatedOrgOrgIdProductsRouteRouteChildren,
  )

interface AuthenticatedOrgOrgIdSettingsRouteRouteChildren {
  AuthenticatedOrgOrgIdSettingsBrandRoute: typeof AuthenticatedOrgOrgIdSettingsBrandRoute
  AuthenticatedOrgOrgIdSettingsGeneralRoute: typeof AuthenticatedOrgOrgIdSettingsGeneralRoute
}

const AuthenticatedOrgOrgIdSettingsRouteRouteChildren: AuthenticatedOrgOrgIdSettingsRouteRouteChildren =
  {
    AuthenticatedOrgOrgIdSettingsBrandRoute:
      AuthenticatedOrgOrgIdSettingsBrandRoute,
    AuthenticatedOrgOrgIdSettingsGeneralRoute:
      AuthenticatedOrgOrgIdSettingsGeneralRoute,
  }

const AuthenticatedOrgOrgIdSettingsRouteRouteWithChildren =
  AuthenticatedOrgOrgIdSettingsRouteRoute._addFileChildren(
    AuthenticatedOrgOrgIdSettingsRouteRouteChildren,
  )

interface AuthenticatedOrgOrgIdTalentsRouteRouteChildren {
  AuthenticatedOrgOrgIdTalentsTalentIdRouteRoute: typeof AuthenticatedOrgOrgIdTalentsTalentIdRouteRoute
  AuthenticatedOrgOrgIdTalentsIndexRoute: typeof AuthenticatedOrgOrgIdTalentsIndexRoute
}

const AuthenticatedOrgOrgIdTalentsRouteRouteChildren: AuthenticatedOrgOrgIdTalentsRouteRouteChildren =
  {
    AuthenticatedOrgOrgIdTalentsTalentIdRouteRoute:
      AuthenticatedOrgOrgIdTalentsTalentIdRouteRoute,
    AuthenticatedOrgOrgIdTalentsIndexRoute:
      AuthenticatedOrgOrgIdTalentsIndexRoute,
  }

const AuthenticatedOrgOrgIdTalentsRouteRouteWithChildren =
  AuthenticatedOrgOrgIdTalentsRouteRoute._addFileChildren(
    AuthenticatedOrgOrgIdTalentsRouteRouteChildren,
  )

interface AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRouteChildren {
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsIndexRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsIndexRoute
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsStpJobIdRouteRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsStpJobIdRouteRoute
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsVtoJobIdRouteRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsVtoJobIdRouteRoute
}

const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRouteChildren: AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRouteChildren =
  {
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsIndexRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsIndexRoute,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsStpJobIdRouteRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsStpJobIdRouteRoute,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsVtoJobIdRouteRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsVtoJobIdRouteRoute,
  }

const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRouteWithChildren =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRoute._addFileChildren(
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRouteChildren,
  )

interface AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsRouteRouteChildren {
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsModelIdRouteRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsModelIdRouteRoute
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsIndexRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsIndexRoute
}

const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsRouteRouteChildren: AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsRouteRouteChildren =
  {
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsModelIdRouteRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsModelIdRouteRoute,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsIndexRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsIndexRoute,
  }

const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsRouteRouteWithChildren =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsRouteRoute._addFileChildren(
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsRouteRouteChildren,
  )

interface AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesRouteRouteChildren {
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesCanvasIdRouteRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesCanvasIdRouteRoute
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesIndexRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesIndexRoute
}

const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesRouteRouteChildren: AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesRouteRouteChildren =
  {
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesCanvasIdRouteRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesCanvasIdRouteRoute,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesIndexRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesIndexRoute,
  }

const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesRouteRouteWithChildren =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesRouteRoute._addFileChildren(
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesRouteRouteChildren,
  )

interface AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterRouteRouteChildren {
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterTalentIdRouteRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterTalentIdRouteRoute
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterIndexRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterIndexRoute
}

const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterRouteRouteChildren: AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterRouteRouteChildren =
  {
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterTalentIdRouteRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterTalentIdRouteRoute,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterIndexRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterIndexRoute,
  }

const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterRouteRouteWithChildren =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterRouteRoute._addFileChildren(
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterRouteRouteChildren,
  )

interface AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesRouteRouteChildren {
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesSceneIdRouteRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesSceneIdRouteRoute
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesIndexRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesIndexRoute
}

const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesRouteRouteChildren: AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesRouteRouteChildren =
  {
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesSceneIdRouteRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesSceneIdRouteRoute,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesIndexRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesIndexRoute,
  }

const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesRouteRouteWithChildren =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesRouteRoute._addFileChildren(
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesRouteRouteChildren,
  )

interface AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRouteChildren {
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsBrandRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsBrandRoute
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsDeletionRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsDeletionRoute
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsGeneralRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsGeneralRoute
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsIntegrationsRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsIntegrationsRoute
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsMembersRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsMembersRoute
}

const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRouteChildren: AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRouteChildren =
  {
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsBrandRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsBrandRoute,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsDeletionRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsDeletionRoute,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsGeneralRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsGeneralRoute,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsIntegrationsRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsIntegrationsRoute,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsMembersRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsMembersRoute,
  }

const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRouteWithChildren =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRoute._addFileChildren(
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRouteChildren,
  )

interface AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductRouteRouteChildren {
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductProductIdRouteRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductProductIdRouteRoute
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductIndexRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductIndexRoute
}

const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductRouteRouteChildren: AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductRouteRouteChildren =
  {
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductProductIdRouteRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductProductIdRouteRoute,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductIndexRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductIndexRoute,
  }

const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductRouteRouteWithChildren =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductRouteRoute._addFileChildren(
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductRouteRouteChildren,
  )

interface AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoRouteRouteChildren {
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoVideoIdRouteRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoVideoIdRouteRoute
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoIndexRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoIndexRoute
}

const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoRouteRouteChildren: AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoRouteRouteChildren =
  {
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoVideoIdRouteRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoVideoIdRouteRoute,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoIndexRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoIndexRoute,
  }

const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoRouteRouteWithChildren =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoRouteRoute._addFileChildren(
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoRouteRouteChildren,
  )

interface AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoRouteRouteChildren {
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoLookIdRouteRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoLookIdRouteRoute
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoIndexRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoIndexRoute
}

const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoRouteRouteChildren: AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoRouteRouteChildren =
  {
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoLookIdRouteRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoLookIdRouteRoute,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoIndexRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoIndexRoute,
  }

const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoRouteRouteWithChildren =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoRouteRoute._addFileChildren(
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoRouteRouteChildren,
  )

interface AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRouteChildren {
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRouteWithChildren
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsRouteRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsRouteRouteWithChildren
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesRouteRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesRouteRouteWithChildren
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterRouteRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterRouteRouteWithChildren
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesRouteRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesRouteRouteWithChildren
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRouteWithChildren
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductRouteRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductRouteRouteWithChildren
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoRouteRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoRouteRouteWithChildren
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoRouteRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoRouteRouteWithChildren
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdIndexRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdIndexRoute
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsAssetIdRouteRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsAssetIdRouteRoute
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsIndexRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsIndexRoute
}

const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRouteChildren: AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRouteChildren =
  {
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdBulkJobsRouteRouteWithChildren,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsRouteRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdModelsRouteRouteWithChildren,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesRouteRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdNodesRouteRouteWithChildren,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterRouteRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRosterRouteRouteWithChildren,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesRouteRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdScenesRouteRouteWithChildren,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSettingsRouteRouteWithChildren,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductRouteRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdSketchToProductRouteRouteWithChildren,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoRouteRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVideoRouteRouteWithChildren,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoRouteRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdVtoRouteRouteWithChildren,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdIndexRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdIndexRoute,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsAssetIdRouteRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsAssetIdRouteRoute,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsIndexRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdAssetsIndexRoute,
  }

const AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRouteWithChildren =
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute._addFileChildren(
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRouteChildren,
  )

interface AuthenticatedOrgOrgIdRouteRouteChildren {
  AuthenticatedOrgOrgIdProductsRouteRoute: typeof AuthenticatedOrgOrgIdProductsRouteRouteWithChildren
  AuthenticatedOrgOrgIdSettingsRouteRoute: typeof AuthenticatedOrgOrgIdSettingsRouteRouteWithChildren
  AuthenticatedOrgOrgIdTalentsRouteRoute: typeof AuthenticatedOrgOrgIdTalentsRouteRouteWithChildren
  AuthenticatedOrgOrgIdIndexRoute: typeof AuthenticatedOrgOrgIdIndexRoute
  AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute: typeof AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRouteWithChildren
  AuthenticatedOrgOrgIdBillingIndexRoute: typeof AuthenticatedOrgOrgIdBillingIndexRoute
  AuthenticatedOrgOrgIdUsageIndexRoute: typeof AuthenticatedOrgOrgIdUsageIndexRoute
  AuthenticatedOrgOrgIdUsersIndexRoute: typeof AuthenticatedOrgOrgIdUsersIndexRoute
}

const AuthenticatedOrgOrgIdRouteRouteChildren: AuthenticatedOrgOrgIdRouteRouteChildren =
  {
    AuthenticatedOrgOrgIdProductsRouteRoute:
      AuthenticatedOrgOrgIdProductsRouteRouteWithChildren,
    AuthenticatedOrgOrgIdSettingsRouteRoute:
      AuthenticatedOrgOrgIdSettingsRouteRouteWithChildren,
    AuthenticatedOrgOrgIdTalentsRouteRoute:
      AuthenticatedOrgOrgIdTalentsRouteRouteWithChildren,
    AuthenticatedOrgOrgIdIndexRoute: AuthenticatedOrgOrgIdIndexRoute,
    AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRoute:
      AuthenticatedOrgOrgIdWorkspaceWorkspaceIdRouteRouteWithChildren,
    AuthenticatedOrgOrgIdBillingIndexRoute:
      AuthenticatedOrgOrgIdBillingIndexRoute,
    AuthenticatedOrgOrgIdUsageIndexRoute: AuthenticatedOrgOrgIdUsageIndexRoute,
    AuthenticatedOrgOrgIdUsersIndexRoute: AuthenticatedOrgOrgIdUsersIndexRoute,
  }

const AuthenticatedOrgOrgIdRouteRouteWithChildren =
  AuthenticatedOrgOrgIdRouteRoute._addFileChildren(
    AuthenticatedOrgOrgIdRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAdminRouteRoute: typeof AuthenticatedAdminRouteRouteWithChildren
  AuthenticatedProfileRouteRoute: typeof AuthenticatedProfileRouteRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedOrgOrgIdRouteRoute: typeof AuthenticatedOrgOrgIdRouteRouteWithChildren
  AuthenticatedE2eMediaRoute: typeof AuthenticatedE2eMediaRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRouteRoute: AuthenticatedAdminRouteRouteWithChildren,
  AuthenticatedProfileRouteRoute: AuthenticatedProfileRouteRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedOrgOrgIdRouteRoute: AuthenticatedOrgOrgIdRouteRouteWithChildren,
  AuthenticatedE2eMediaRoute: AuthenticatedE2eMediaRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  authRouteRoute: authRouteRouteWithChildren,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  TermsOfServiceRoute: TermsOfServiceRoute,
  AuthAcceptInviteRoute: AuthAcceptInviteRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthInvitationRoute: AuthInvitationRoute,
  AuthMcpCallbackRoute: AuthMcpCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
